import React from 'react';
import * as PropTypes from 'prop-types';

import { renderElectronicConsentHeader } from '../utils/renderElectronicConsentHeader';
import getElectronicConsentHeaderRenderData from '../../../utils/getElectronicConsentHeaderRenderData';
import styles from './index.styl';

export function ElectronicConsentListItem({ entity, formatMessage, onClick }) {
  const {
    assignedBy,
    consentName,
    organizationName,
    formatTime,
    id,
  } = getElectronicConsentHeaderRenderData(entity, formatMessage);

  return (
    <div className={styles.root} onClick={onClick} key={id}>
      {renderElectronicConsentHeader(
        formatMessage,
        assignedBy,
        consentName,
        organizationName,
        formatTime,
      )}
    </div>
  );
}

ElectronicConsentListItem.defaultProps = {
  onClick: null,
};

ElectronicConsentListItem.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
  onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ElectronicConsentListItem/index.jsx